"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.specificationVersion = exports.implementationVersion = exports.evaluate = exports.isInt = exports.isCertLogicOperation = exports.isCertLogicExpression = exports.timeUnits = void 0;
var typings_1 = require("./typings");
Object.defineProperty(exports, "timeUnits", { enumerable: true, get: function () { return typings_1.timeUnits; } });
var index_1 = require("./validation/index"); // also exposed here to not break API
Object.defineProperty(exports, "isCertLogicExpression", { enumerable: true, get: function () { return index_1.isCertLogicExpression; } });
Object.defineProperty(exports, "isCertLogicOperation", { enumerable: true, get: function () { return index_1.isCertLogicOperation; } });
var internals_1 = require("./internals"); // (export other internals only when necessary)
Object.defineProperty(exports, "isInt", { enumerable: true, get: function () { return internals_1.isInt; } });
var evaluator_1 = require("./evaluator");
Object.defineProperty(exports, "evaluate", { enumerable: true, get: function () { return evaluator_1.evaluate; } });
exports.implementationVersion = require("../package.json").version;
exports.specificationVersion = "1.3.2";
